const SET_IS_SHOW_SHARE = "SET_IS_SHOW_SHARE"

const state = {
  isShowShare: false
}

const mutations = {
  [SET_IS_SHOW_SHARE](state, isShowShare) {
    state.isShowShare = isShowShare
  }
}

export default {
  state,
  mutations
}
